import { useEffect, useState } from "react";
import './dates.css';
import api from '../../api/axios';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Dates = ({ navbarHeight }) => {

    const { t } = useTranslation();
    const [events, setEvents] = useState([]);
    const [showLoginWarning, setShowLoginWarning] = useState(false);
    const navigate = useNavigate();
    const [pictureSrc, setPictureSrc] = useState("");

    // Navbar height handling is now done via CSS padding
    useEffect(() => {

        const fetchPicture = async () => {
            try {
                const pictureId = 11; // 🔹 hardcoded for now, can vary per site later
                const response = await api.get(`/user/getwebsitepicture/${pictureId}`);
                setPictureSrc(response.data.picture); // base64 string
            } catch (err) {
                console.error("Error fetching picture:", err);
            }
        };

        fetchPicture();
    }, []);

    useEffect(() => {
        // Fetch events from the backend
        api.get('/user/homepageevents')
            .then(res => {
                setEvents(res.data);
            })
            .catch(err => {
                console.error("Fehler beim Laden der Events:", err);
            });
    }, []);

    const handleEventClick = () => {
        const token = sessionStorage.getItem('token');

        if (token) {
            navigate('/eventsstore');
        } else {
            setShowLoginWarning(true);
            setTimeout(() => setShowLoginWarning(false), 5000); // Hide after 5 sec
        }
    };

    return (
        <div className="wrapper-dates" id="dates">
            <div className="dates-parent">
                <div className="terminkalender-parent">
                    <iframe id="calendar" title="calendar" src="https://calendar.google.com/calendar/embed?src=de.german%23holiday%40group.v.calendar.google.com&ctz=Europe%2FBerlin"></iframe>
                </div>
                <div className="next-dates-wrapper" id="next-dates">
                    <div className="next-dates">
                        {pictureSrc ? (
                            <img src={pictureSrc} alt="Barmatch" />
                        ) : (
                            <p>{t('LoadingPic')}</p>
                        )}
                        <div className="barmatch-click-instruction">
                            <p>&rarr; {t('NextDates')}</p>
                        </div>
                        {showLoginWarning && (
                            <div className="login-warning-popup">
                                <p>
                                    {t('LoginForDates')}
                                </p>
                            </div>
                        )}
                        <table className="date-table">
                            <tbody>
                                {events.map((event, index) => (
                                    <tr
                                        key={index}
                                        onClick={handleEventClick}
                                        className="clickable-event-row"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <td className="single-events">{event.eventname}</td>
                                        <td className="single-dates">
                                            {new Date(event.date).toLocaleDateString('de-DE', {
                                                day: '2-digit',
                                                month: '2-digit'
                                            })}
                                        </td>
                                    </tr>
                                ))}
                                <tr>
                                    <td className="single-events" onClick={handleEventClick}>{t('AndManyMore')}</td>
                                </tr>
                                {events.length === 0 && (
                                    <tr>
                                        <td colSpan={2}>{t('NoEventFound')}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dates